import React from 'react';
import { Grid } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

export default function PageContainer(props) {
  const [isDesktop] = useCheckScreenSize();

  return (
    <>
      {useMediaQuery('(min-width:1000px)') ? (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{
            width: props.noDesktopSupport
              ? '100%'
              : `calc(100% - ${isDesktop ? 300 : 0}px)`,
          }}
        >
          {props.children}
        </Grid>
      ) : (
        <Grid
          direction="row"
          justify="center"
          alignItems="center"
          style={{
            width: props.noDesktopSupport
              ? '100%'
              : `calc(100% - ${isDesktop ? 300 : 0}px)`,
          }}
        >
          {props.children}
        </Grid>
      )}
    </>
  );
}
